// Danh sách swUsername còn được phép dùng giao diện cũ sau khi V1 đã đóng.
// THÊM/BỚT NGƯỜI DÙNG Ở ĐÂY. So sánh không phân biệt hoa thường và bỏ khoảng trắng thừa.
export const V1_ALLOWED_USERS = [
  "sota/liemdd", "sota/thailinh"
];

export function isAllowedV1(swUsername) {
  if (!swUsername) return false;
  const name = String(swUsername).trim().toLowerCase();
  return V1_ALLOWED_USERS.some(allowed => String(allowed).trim().toLowerCase() === name);
}

// JWT dùng base64url (- _ thay cho + /) và có thể thiếu padding.
function decodeBase64Url(segment) {
  let base64 = String(segment).replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4 !== 0) base64 += "=";
  return atob(base64);
}

// swUsername nằm trong HEADER của accessToken (segment đầu), nên đọc được ngay lúc khởi động
// mà không phải chờ /api/auth/verify.
export function getSwUsernameFromToken() {
  try {
    const token = localStorage.getItem("userToken");
    if (!token) return "";
    const header = JSON.parse(decodeBase64Url(token.split(".")[0]));
    return header.swUsername || "";
  } catch (e) {
    return "";
  }
}
